/**
 * Helper for creating `shouldForwardProp` functions.
 *
 * @param blockList a list of props NOT to forward
 * @returns a `shouldForwardProp` function
 */
export const blockProps = (blockList: readonly string[]) => {
  const blockSet = new Set(blockList);

  return (prop: string) => !blockSet.has(prop);
};
